export default __webpack_public_path__ + "static/media/lab1.bfc5ad18.png";